module.exports = __webpack_public_path__ + "annualreview2018/static/pdfs/sections--people.004c0fe.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/sections--people.pdf
// module id = ugOV
// module chunks = 10